import { render } from "./ApartmentPage.vue?vue&type=template&id=5399402c&scoped=true"
import script from "./ApartmentPage.vue?vue&type=script&lang=js"
export * from "./ApartmentPage.vue?vue&type=script&lang=js"

import "./ApartmentPage.vue?vue&type=style&index=0&id=5399402c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5399402c"]])

export default __exports__